import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationsRoutingModule } from './notifications-routing.module';
import { NotificationsIndexComponent } from './pages/notifications-index/notifications-index.component';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '$shared/directives/directives.module';
import { PipesModule } from '$shared/pipes/pipes.module';
import { ShowNotificationComponent } from './pages/show-notification/show-notification.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NotificationCounterComponent } from './components/notification-counter/notification-counter.component';
import { NotificationSettingsModalComponent } from './components/notification-settings-modal/notification-settings-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@NgModule({
  declarations: [
    NotificationsIndexComponent,
    ShowNotificationComponent,
    NotificationCounterComponent,
    NotificationSettingsModalComponent,
  ],
  imports: [
    CommonModule,
    NotificationsRoutingModule,
    TranslateModule,
    DirectivesModule,
    PipesModule,
    FontAwesomeModule,
    FormsModule,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
  ],
  exports: [NotificationCounterComponent],
})
export class NotificationsModule {}
